module.exports = __webpack_public_path__ + "static/media/map-silkroad.42f2509c.png";